<template>
  <div >
    <div v-if="value &&  value.submissionDate">
        <div class="d-flex justify-space-between flex-column flex-sm-row">
            <router-link class="my-auto" style="text-decoration: none;" :to="{name: 'staffRequirementSubmissionView', params: {id: value.submissionId }}">
                <span v-if="requirement.type =='Vaccination'">Dose {{forDoseNumber}} submitted</span>
                <span v-else>Submitted</span>
                on  {{value.submissionDate | formatDateYear}}
            </router-link>
            
            <!--
              An expired certificate used to render exactly like a valid one:
              plain light text, no colour, no icon. A lapsed item was therefore
              invisible on the page where staff are actually managed
              (ticket cmutq4oby77lc01qr3nvg68mh).
            -->
            <div
                v-if="requirement.type == 'Certification'"
                :class="isExpired(requirement) ? 'error--text font-weight-medium' : 'font-weight-light'"
            >
                <v-icon v-if="isExpired(requirement)" small color="error" class="mr-1">mdi-alert-circle</v-icon>
                {{certificationPeriod(requirement)}}
                <span v-if="isExpired(requirement)">(Expired)</span>
            </div>
            <div v-if="value.state == 'pending'">
                <v-btn disabled text>Pending</v-btn>
            </div>

            <!-- <v-btn text class="mx-0 mt-2 mt-md-0 px-0 mx-md-2" :to="{name: 'staffRequirementSubmissionView', params: {id: value.submissionId }}">View Submission</v-btn> -->
        </div>
        <!-- <v-btn :to="{name: 'staffRequirementSubmissionView', params: {id: value.submissionId }}" icon><v-icon small>mdi-open-in-new</v-icon></v-btn> -->
    </div>
    <div class="d-flex justify-space-between flex-column flex-sm-row" v-else>
        <span class="my-auto" v-if="requirement.type =='Vaccination'">Dose {{forDoseNumber}} due on {{value.dueDate | formatDateYear}}</span>
        <span class="my-auto" v-if="requirement.type =='Certification'">
            <span v-if="value.dueDate"> 
                Due on {{value.dueDate | formatDateYear}}
            </span>
            <span>
                No record
            </span>
        </span>
        <span class="my-auto" v-if="requirement.type =='Required Documents'">
            No record
        </span>

        <div class="d-flex">
            <v-checkbox v-model="value.selected" @change="$emit('selectionChanged', {state: value.selected, requirement, forDoseNumber})" class="my-auto ml-auto mt-2 mt-md-0" v-if="selectMode" hide-details/>
            <v-btn :disabled="disabled" v-else class="mx-0 mt-2 mt-md-0 px-0 mx-md-2" :to="{path: `/staffRequirementSubmission/create`, query: {staffId: staff.id, requirements: `${requirement.requirementId}_${forDoseNumber}`}}" text>Submit</v-btn>
        </div>
    </div>

    <v-dialog>
        <v-card>
            <v-card-title>{{requirement.name}} Submission Proof</v-card-title>
        </v-card>
        <v-card-text>
            <div>
             Approved By: {{'show approved staff here..'}}
            </div>
            <div>
             Submitted One: {{'show approved staff here..'}}
            </div>
            <div>
             Approved By: {{'show approved staff here..'}}
            </div>
            Submitted On: {{'show approved staff here..'}}
            show image or documents below...
        </v-card-text>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        value: { 
            type: Object,
            required: false
        },
        requirement: { 
            type: Object,
            required: true
        },
        staff: { 
            type: Object,
            required: true
        },
        selectMode: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => {
        return { }
    },
    computed: {
        forDoseNumber() {
           return this.value && this.value.dose ? this.value.dose:1;
        }
    },
    mounted(){
        console.log('mount staff req status:....')
    },
    created(){
    },
    methods:{
        viewProof(){
            console.log('view proof...')
        },
        certificationPeriod(requirement){
            if(requirement && requirement.staffSubmissionRequirements && requirement.staffSubmissionRequirements.length > 0){
                const submission = requirement.staffSubmissionRequirements[0];
                const issueDate = this.$options.filters.formatDateYear(submission.cerfIssueDate);
                const expireDate = this.$options.filters.formatDateYear(submission.cerfExpireDate);
                return `${issueDate} - ${expireDate}`;
            }
        },
        /**
         * True when this certificate's expiry date has passed. Same comparison
         * the calendar uses (calendarServices.js), so the two screens agree.
         */
        isExpired(requirement){
            if(!requirement || requirement.type !== 'Certification') return false;
            const subs = requirement.staffSubmissionRequirements;
            if(!subs || subs.length === 0) return false;
            const expire = subs[0].cerfExpireDate;
            if(!expire) return false;
            return moment(expire).isBefore(moment());
        }
    }
}
</script>

<style>

</style>